import { colorWhite, getGradientBackground, styles } from "@/components/Styles"
import FitOneLineText from "@/components/utils/FitOneLineText"
import { Typography } from "@mui/material"
import withStyles from "@mui/styles/withStyles"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

const propTypes = {
  classes: PropTypes.shape().isRequired,
  accessScreen: PropTypes.bool,
}

function CustomerPaperHeader({ classes, accessScreen }) {
  const customer = useSelector(({ customer: storeCustomer }) => storeCustomer.user.customer)
  return (
    <>
      {accessScreen ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 25,
            marginBottom: 25,
            gap: 20,
          }}
        >
          <img
            alt="Customer Logo"
            src={customer.imgUrl}
            style={{ width: 100, height: 100 }}
            // src={
            // 	"https://s3-us-west-2.amazonaws.com/elodyn-public/760ee0674b314b088849c0ba9d8ef9ff.png"
            // }
          />
          <FitOneLineText text={customer.name} variant="h4" />
        </div>
      ) : (
        <div
          className={`${classes.hero} ${classes.backgroundColorPrimary800} flex-align-center`}
          style={customer.backgroundImgUrl ? getGradientBackground(customer.backgroundImgUrl) : {}}
        >
          {customer.imgUrl && (
            <div>
              <img alt="Customer Header" className={classes.avatar} src={customer.imgUrl} />
            </div>
          )}
          <div className={classes.paddingLeft16}>
            <Typography style={colorWhite} variant="h4">
              {customer.nameShort}
            </Typography>
            <div className="flex-align-center">
              <Typography style={colorWhite}>
                {!customer.isRoot &&
                  customer.totalMembers &&
                  `${customer.totalMembers} Member${customer.totalMembers === 1 ? "" : "s"}`}
              </Typography>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

CustomerPaperHeader.propTypes = propTypes

export default withStyles(styles)(CustomerPaperHeader)
